const normalizedPayments = paymentMethods =>
  Array.isArray(paymentMethods)
    ? paymentMethods.map(String)
    : String(paymentMethods || '')
        .split(',')
        .filter(Boolean);

const requiresExtendedDeadline = paymentMethods =>
  normalizedPayments(paymentMethods).some(value => ['2', '3'].includes(value));

export const defaultDeadlineForPayment = paymentMethods => {
  const payments = normalizedPayments(paymentMethods);
  if (requiresExtendedDeadline(payments)) return '45';
  if (payments.includes('1')) return '30';
  return '';
};

export const defaultDeadlineForDayType = (paymentMethods, dayType) => {
  if (!requiresExtendedDeadline(paymentMethods)) return '';
  return String(dayType) === '2' ? '65' : '45';
};
